import { Component } from '@angular/core';

@Component({
    selector: 'ca-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
})
export class TableComponent {}
